import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TranscriptsIcon from './transcripts-icon';
class TranscriptsWidget extends Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
        require('./transcripts-widget.scss');

    }


    render() {
        return (
            <div className="widget-container">
              <a ref={this.ref} className="mtv-transcripts-widget" onClick={this.props.onClick}>
                <div className="label-container">
                  <div className="icon"><TranscriptsIcon /></div>
                  <div className="label">Transcripts</div>
                </div>
              </a>
            </div>
        );

    }
    static get propTypes() {
        return {
            onClick: PropTypes.func
        }
    }

    static get defaultProps() {
        return {
            onClick: () => {}
        }
    }
}


export default TranscriptsWidget